<template>
	<page>
		<module>
			<module-col size="600" title="批量传图">
				<c-form ref="form" vertical unit-width="100%">
					<c-form-item label="业务对象" required label-tip="选择上传匹配和导入的目标业务">
						<c-select v-model="workType" name="business_object" :options="workTypeOption" :clear="false"></c-select>
					</c-form-item>
					<c-form-item v-show="workType == 'work'" label="匹配范围" required label-tip="可选择要匹配的数据范围">
						<c-checkbox-group name="match_scopes">
							<c-checkbox value="not_started">未开始</c-checkbox>
							<c-checkbox value="in_progress">执行中</c-checkbox>
							<c-checkbox value="ended_30d">30天内已结束</c-checkbox>
						</c-checkbox-group>
					</c-form-item>
					<c-form-item label="匹配字段" required label-tip="从目标业务对象中选择一个字段数据作为比对对象与文件名进行匹配">
						<c-select v-model="matchField" name="match_field_code" :options="matchFieldOption" :clear="false"></c-select>
					</c-form-item>
					<c-form-item label="文件后缀分隔符" required label-tip>
						<template #labelTip>
							<p>当文件名中包含分隔符时，在匹配过程中会将分隔符后的字符会被忽略。</p>
							<p>如：GD00001-01.jpg，会截取GD00001参与匹配。</p>
						</template>
						<c-select name="separator" :options="separatorOption" :clear="false"></c-select>
					</c-form-item>
					<c-form-item label="导入字段" required label-tip="从目标业务对象中选择一个字段作为导入数据存储字段">
						<c-select v-model="importField" name="import_field_code" :options="importFieldOption" :clear="false"></c-select>
					</c-form-item>
					<c-form-item label="上传文件" required>
						<c-upload-file name="file_names" :type="importFieldSuffix" multiple></c-upload-file>
					</c-form-item>
					<c-form-item label="匹配方式" required label-tip>
						<template #labelTip>
							<p>匹配字段数据与处理后的文件名的比对方式。</p>
							<p>精准匹配：匹配字段数据与文件名完全相同的数据；</p>
							<p>前缀匹配：匹配字段数据以文件名开头的数据；</p>
							<p>后缀匹配：匹配字段数据以文件名结尾的数据；</p>
						</template>
						<c-radio-group name="match_mode">
							<c-radio value="1">精准匹配</c-radio>
							<c-radio value="2">前缀匹配</c-radio>
							<c-radio value="3">后缀匹配</c-radio>
						</c-radio-group>
					</c-form-item>
					<c-form-item label="导入方式" required label-tip>
						<template #labelTip>
							<p>匹配结果写入导入字段的方式。</p>
							<p>覆盖导入：如果导入字段已存在数据将会被匹配结果数据替换；</p>
							<p>追加导入：保留原文件，匹配结果添加到旧文件之前，仅多选字段支持；</p>
						</template>
						<c-radio-group name="import_mode">
							<c-radio value="1">覆盖导入</c-radio>
							<c-radio v-show="importFieldMultiple" value="2">追加导入</c-radio>
						</c-radio-group>
					</c-form-item>
				</c-form>
				<template #button>
					<c-button size="form" @click="resetHandle('match')">重置</c-button>
					<c-button size="form" color="main" @click="matchHandle">开始匹配</c-button>
				</template>
			</module-col>

			<module-col title="文件匹配结果" enable-flex>
				<template #head>
					<p v-if="matchConfig" style="margin-left: 20px; line-height: 46px; font-size: 14px; color: #666;">选择了<span style="color: #FF6666">{{matchConfig.imageCount}}</span>文件，成功匹配到<span style="color: #05AD5D">{{matchConfig.successCount}}</span>条数据</p>
				</template>

				<c-table v-if="matchConfig" ref="list" height="grow" :paging="false">
					<c-table-column
						type="index"
						width="32"
					></c-table-column>
					
					<c-table-column
						:label="matchConfig.dataFieldTitle || '匹配字段'"
						:ellipsis="false"
					>
						<template #default="{data}">
							<p v-if="data.error" style="color: #f55;">{{data.error}}</p>
							<p v-else-if="!matchConfig.multiple && data.files.length > 1" style="color: #f55;">导入字段为单选字段，无法导入多个文件</p>
							<p v-else>{{data[matchConfig.dataFieldCode]}}</p>
						</template>
					</c-table-column>

					<c-table-column
						label="匹配文件"
						width="200"
					>
						<template #default="{data}">
							<c-file-list :value="data.files.map(item => item.file_url)"></c-file-list>
						</template>
					</c-table-column>
					
					<c-table-column
						type="button"
						label="操作"
						width="100"
						fixed-width
					>
						<template #default="row">
							<c-table-button color="red" @click="row.remove()">删除</c-table-button>
						</template>
					</c-table-column>

					<template #empty>
						<c-empty message="未匹配到数据"></c-empty>
					</template>
				</c-table>
				<c-empty v-else message="请在左侧上传文件"></c-empty>

				<template v-if="matchConfig" #button>
					<c-button size="form" color="main" @click="importHandle">导入匹配成功的文件</c-button>
				</template>
			</module-col>
		</module>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				workTypeOption: [{
					name: '工单',
					value: 'work',
					fieldTitle: '工单编号',
					fieldCode: 'work_code'
				}, {
					name: '产品',
					value: 'product',
					fieldTitle: '产品编号',
					fieldCode: 'product_code'
				}],
				workType: '',

				matchFieldOption: [],
				matchField: '',
				importFieldOption: [],
				importField: '',

				separatorOption: [{
					name: '_（下划线）',
					value: '_'
				}, {
					name: '-（短横/减号）',
					value: '-'
				}, {
					name: '#（井号）',
					value: '#'
				}],

				matchConfig: null
			}
		},

		computed: {
			matchFieldData() {
				return this.matchFieldOption.find(item => item.value == this.matchField) || null;
			},

			importFieldData() {
				return this.importFieldOption.find(item => item.value == this.importField) || null;
			},

			importFieldSuffix() {
				return this.importFieldData
					? this.importFieldData.data.config_json.type == 'file' ? this.importFieldData.data.config_json.suffix.join(',') : 'image'
					: '';
			},

			importFieldMultiple() {
				return !this.importFieldData || this.importFieldData.data.config_json.attr.includes('multiple');
			}
		},

		watch: {
			workType() {
				this.updateField();
			},

			importFieldMultiple() {
				this.$refs.form.set({
					import_mode: 1
				})
			}
		},

		mounted() {
			this.resetHandle('match');
		},
		
		methods: {
			updateField() {
				this.request({
					url: '/batch/upload/fields',
					data: {
						business_object: this.workType
					},
					loading: true,
					success: data => {
						this.matchFieldOption = data.match_fields.map(item => {
							return {
								name: item.field_title,
								value: item.field_code,
								data: item
							}
						});
						this.importFieldOption = data.import_fields.map(item => {
							return {
								name: item.field_title,
								value: item.field_code,
								data: item
							}
						});
						this.$refs.form.set({
							match_field_code: data.match_fields[0] ? data.match_fields[0].field_code : '',
							import_field_code: data.import_fields[0] ? data.import_fields[0].field_code : ''
						});
					}
				})
			},

			matchHandle() {
				this.$refs.form.submit({
					url: '/batch/upload/match',
					rule: {
						match_scopes: [{
							type: 'empty',
							message: '请至少选择一项匹配范围',
							skip: () => {
								return this.workType != 'work';
							}
						}],
						match_field_code: '请选择匹配字段',
						import_field_code: '请选择导入字段',
						file_names: '请上传文件'
					},
					dataFormatter: data => {
						data.match_field_kind = this.matchFieldData.data.field_kind;
						data.file_names = data.file_names.map(item => {
							let info = this.parseFile(item);
							return {
								file_name: `${info.name}${info.suffix ? '.' : ''}${info.suffix}`,
								file_url: item
							}
						});
						return data;
					},
					success: (data, res) => {
						this.$message({
							message: '匹配完成'
						});
						let workType = this.workTypeOption.find(item => item.value == data.business_object);
						this.matchConfig = {
							workType: data.business_object,
							importField: data.import_field_code,
							importMode: data.import_mode,
							multiple: this.importFieldMultiple,
							dataFieldTitle: workType.fieldTitle,
							dataFieldCode: workType.fieldCode,
							imageCount: data.file_names.length,
							successCount: res.success_count
						}
						this.$nextTick(() => {
							this.$refs.list.setData(res.groups);
						});
					}
				})
			},

			importHandle() {
				let list = this.$refs.list.getData().filter(item => {
					return item.matched && (this.matchConfig.multiple || item.files.length == 1);
				}).map(item => {
					return {
						data_ids: item.data_ids,
						file_paths: item.files.map(temp => this.getRealPath(temp.file_url))
					}
				});
				if (!list.length) {
					this.$message({
						message: '暂无匹配结果'
					});
					return;
				}
				this.request({
					url: '/batch/upload/confirm',
					data: {
						business_object: this.matchConfig.workType,
						import_field_code: this.matchConfig.importField,
						import_mode: this.matchConfig.importMode,
						items: list
					},
					success: () => {
						this.$message({
							message: '导入成功'
						});
						this.resetHandle('import');
					}
				})
			},

			resetHandle(type) {
				if (type == 'match') {
					this.$refs.form.clear();
					this.$refs.form.set({
						business_object: this.workTypeOption[0].value,
						match_scopes: 'not_started',
						match_field_code: this.matchFieldOption[0] ? this.matchFieldOption[0].value : '',
						import_field_code: this.importFieldOption[0] ? this.importFieldOption[0].value : '',
						separator: this.separatorOption[0].value,
						match_mode: 1,
						import_mode: 1
					});
				} else {
					this.matchConfig = null;
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>